module.exports = __webpack_public_path__ + "img/propvest_icon.1ac58136.svg";